import React from 'react';
import EventTypeForm from './forms/EventTypeForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { EventType, EventTypeDataForm } from '../../../app/models/EventType';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    eventType: EventTypeDataForm;
    setEventType: (EventType: EventType) => void;
    errorFields?: any;
    setErrorFields?: (errors: any) => void;
}

const EventTypeFormContainer = ({
    fetching,
    action,
    cancel,
    eventType,
    setEventType,
    errorFields = null,
    setErrorFields
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <EventTypeForm
                        eventTypeForm={eventType}
                        setEventTypeForm={setEventType}
                        errorFields={errorFields}
                        setErrorFields={setErrorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default EventTypeFormContainer;
